import { FC } from 'react';

import { regPlatformTheme } from '@/styles/regPlatformTheme';

import styled from '@emotion/styled';
import { useAuth } from '../../../../hooks/useAuth';

export const UserProfile: FC = () => {
  const { user, logout } = useAuth();
  const profileData = user?.profile && getProfileData(user.profile.given_name, user.profile.family_name, user.profile.name);

  if (!profileData) return null;

  return (
    <Profile>
      <div className="profile-image">{profileData.initials}</div>
      <div className="logout">
        <strong>{profileData.userName}</strong>
        <StyledDividerSpan>|</StyledDividerSpan>
        <button onClick={() => logout()}>Log out</button>
      </div>
    </Profile>
  );
};

function getProfileData(givenName?: string, familyName?: string, name?: string | null): { initials: string; userName: string } | undefined {
  if (givenName && familyName) {
    return {
      userName: `${givenName} ${familyName}`,
      initials: `${givenName[0]}${familyName[0]}`,
    };
  } else if (name) {
    return {
      userName: name,
      initials: name[0],
    };
  }

  return undefined;
}

const Profile = styled.div`
  align-items: center;
  display: flex;
  gap: 6px;
  justify-content: flex-end;

  .profile-image {
    align-items: center;
    border: 2px solid ${regPlatformTheme.colors.indigo};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    font-size: 12px;
    text-transform: uppercase;
    width: 30px;
    height: 30px;
    background-color: rgb(35, 8, 90);
    font-weight: lighter;
    color: white;
  }

  &&& button {
    padding: 0 !important;
    cursor: pointer;
  }
`;

export const StyledDividerSpan = styled.span`
  font-size: 18px;
  padding: 0 21px;
`;
